import { createContext, useState } from "react"
import API from "services/api"

export const LogRecordalContext = createContext({})

const LogRecordalProvider = (props) => {
	const [logrecordals, setLogrecordals] = useState([])
	const [openHistory, setOpenHistory] = useState(false)

	const onOpenHistory = () => {
		setOpenHistory(!openHistory)
	}

	const getLogRecordals = (params) => {
		return API.getLogRecordals(params)
			.then((res) => {
				const { data } = res
				setLogrecordals(data)

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getLogRecordalByParent = (id, params) => {
		return API.getLogRecordalByParent(id, params)
			.then((res) => {
				const { data } = res
				setLogrecordals(data)

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const postLogRecordals = (data) => {
		return API.postLogRecordals(data)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const putLogRecordals = (id, data) => {
		return API.putLogRecordals(id, data)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const deleteLogRecordals = (id) => {
		return API.deleteLogRecordals(id)
			.then((res) => {
				const { data } = res

				return data
			})
			.catch((err) => {
				throw err
			})
	}

	return (
		<LogRecordalContext.Provider
			value={{
				logrecordals,

				getLogRecordals,
				getLogRecordalByParent,
				postLogRecordals,
				putLogRecordals,
				deleteLogRecordals,

				openHistory,
				onOpenHistory
			}}
			{...props}
		/>
	)
}

export default LogRecordalProvider
